<template>
  <div id="m-configs" style="height: 100%">
    <v-overlay v-if="loading">
      <v-progress-circular indeterminate color="primary"/>
    </v-overlay>
    <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
      {{ message }}
    </v-alert>
    <v-card v-else elevation="0">
      <v-card-actions style="height: 70px!important;">
        <v-tabs v-model="tab" class="no-transition">
          <v-tab :disabled="!ifCanViewMyConfigs()">My Configs
            <v-icon size="20" style="margin-left: 8px">mdi-strategy</v-icon>
          </v-tab>
          <v-tab :disabled="!ifCanViewPreReleaseConfigs()">Pre Release
            <v-icon size="20" style="margin-left: 8px">mdi-shield-alert-outline</v-icon>
          </v-tab>
          <v-tab :disabled="!ifCanViewReleaseConfigs()">Release
            <v-icon size="20" style="margin-left: 8px">mdi-shield-check-outline</v-icon>
          </v-tab>
          <v-tab :disabled="!ifCanViewMasterConfigs()">Master
            <v-icon size="22" style="margin-left: 8px">mdi-crown-outline</v-icon>
          </v-tab>
          <v-tab :disabled="!ifCanViewMergeHistory()">Merge History
            <v-icon size="22" style="margin-left: 8px">mdi-history</v-icon>
          </v-tab>
          <v-tab>Shared Configs
            <v-icon size="20" style="margin-left: 8px">mdi-share-variant-outline</v-icon>
          </v-tab>
        </v-tabs>
      </v-card-actions>
      <v-card-actions class="ma-0 pa-0 mx-2" style="border-bottom: green solid 0px;">
        <v-card width="100%" class="ma-0 pa-0 scroll" elevation="0" :height="winsize.height - 145">
          <v-tabs-items class="mt-0" v-model="tab">
            <v-tab-item
                transition="fade-transition"
                reverse-transition="fade-transition">
              <c-l></c-l>
            </v-tab-item>
            <v-tab-item
                transition="fade-transition"
                reverse-transition="fade-transition">
              <c-pre-release></c-pre-release>
            </v-tab-item>
            <v-tab-item
                transition="fade-transition"
                reverse-transition="fade-transition">
              <c-release></c-release>
            </v-tab-item>
            <v-tab-item
                transition="fade-transition"
                reverse-transition="fade-transition">
              <c-master></c-master>
            </v-tab-item>
            <v-tab-item
                transition="fade-transition"
                reverse-transition="fade-transition">
              <merge-history></merge-history>
            </v-tab-item>
            <v-tab-item
                transition="fade-transition"
                reverse-transition="fade-transition">
              <c-shared-configs></c-shared-configs>
            </v-tab-item>
            <v-tab-item
                transition="fade-transition"
                reverse-transition="fade-transition">
              <c-branch></c-branch>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>

import ConfigStore from "@/modules/mconfigs/database/ConfigStore";
import ConfigBackend from "@/modules/mconfigs/database/ConfigBackend";
import BranchStore from "@/modules/mconfigs/database/BranchStore";

import CL from "@/modules/mconfigs/views/list/c-l";
import CPreRelease from "@/modules/mconfigs/views/pre-release/c-pre-release";
import CRelease from "@/modules/mconfigs/views/release/c-release";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import CMaster from "@/modules/mconfigs/views/master/c-master";
import MergeHistory from "@/modules/mconfigs/views/merge-history/merge-history";
import HeroKindStore from "@/modules/mherokind/database/HeroKindStore";
import { WorkerKind } from "../redactor/models/worker/WorkerKind";
import CPreReleaseManagement from "@/modules/mconfigs/views/pre-release/c-pre-release-management.vue";
import CSharedConfigs from "@/modules/mconfigs/views/shared/c-shared-configs";

export default {
  components: {MergeHistory, CMaster, CPreRelease, CRelease, CL, CBranch: CPreReleaseManagement, CSharedConfigs},
  data: () => ({
    loading: true,
    message: "",
    tab: 0,
    time:0,
  }),
  computed: {
    winsize() {
      return window.app.winsize;
    },
    tabCode() {
      return ["my", "pre", "release", "master", "history", "shared", "branch"][this.tab] || "my";
    }
  },
  methods: {
    getMyUserUid() {
      return PermissionsStoreUtils.getMyUserUid();
    },
    ifCanViewMyConfigs() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_VIEW_MY_CONFIGS.id)
    },
    ifCanViewPreReleaseConfigs() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_VIEW_PRERELEASE.id)
    },
    ifCanViewReleaseConfigs() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_VIEW_RELEASE.id)
    },
    ifCanViewMasterConfigs() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MASTER_CONFIGS.id)
    },
    ifCanViewMergeHistory() {
      return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.CONFIG_TAB.subpermissions.CONFIG_TAB_MERGE_HISTORY.id)
    },
    validate() {
      ConfigStoreUtils.validate()
    },
    getTimestampInMiliSeconds () {
        return Math.floor(Date.now())
    },
  },
  watch: {
    tabCode(newVal) {
      if (newVal === "pre" && this.ifCanViewPreReleaseConfigs()) {
        ConfigStoreUtils.fetchReleaseConfigs().catch(e => {
          console.error(e);
          this.$alert("Failed to refresh Pre Release configs");
        });
      }
      if (newVal === "shared") {
        ConfigStoreUtils.fetchSharedConfigs().catch(e => {
          console.error(e);
          this.$alert("Failed to refresh Shared configs");
        });
      }
    },
  },
  beforeMount() {

    this.time = this.getTimestampInMiliSeconds();

    this.$store.registerModule("backend-store", ConfigBackend);
    this.$store.dispatch("backend-store/init").then(() => {

      console.log("Loaded successfully. backend-store", this.getTimestampInMiliSeconds() - this.time, "ms");
      this.time = this.getTimestampInMiliSeconds();

        WorkerKind.fetchWorkerKinds().then(() => {
          console.log("Loaded successfully. worker-kind-store");
          if(!this.$store.hasModule(['hero-kind-store'])){
            this.$store.registerModule("hero-kind-store", HeroKindStore);
            this.$store.dispatch("hero-kind-store/init").then(() => {
              console.log("Loaded successfully. hero-kind-store");
            }).catch(() => {
              console.error("Failed to load hero kinds.");
            })
          }
        }).catch(() => {
          console.error("Failed to load hero kinds.");
        });

        this.$store.registerModule("config-store", ConfigStore);
        this.$store.dispatch("config-store/init").then(() => {
          console.log("Loaded successfully. config-store", this.getTimestampInMiliSeconds() - this.time, "ms");
          ConfigStoreUtils.fetchSharedConfigs().then(() => {
            console.log("Loaded successfully. shared-configs");
          }).catch((e) => {
            console.error("Failed to load shared configs:", e);
          });
        }).catch((e) => {
          this.message = "Load failed!" + e;
          this.loading = false;
        });

        this.$store.registerModule("branch-store", BranchStore);
        this.$store.dispatch("branch-store/init").then(() => {
          console.log("Loaded successfully. branch-store", this.getTimestampInMiliSeconds() - this.time, "ms");
        }).catch((e) => {
          this.message = "Load failed!" + e;
        }).finally(() => {
          this.loading = false;
        });
    })
  },



  destroyed() {
    this.$store.unregisterModule("config-store");
    this.$store.unregisterModule("backend-store");
    this.$store.unregisterModule("branch-store");
    console.log("destroy root view mconfigs");
  }
}
</script>

<style scoped>
.scroll {
  overflow-y: scroll
}
</style>